// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.messageProfile {
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 100%;
  overflow-y: scroll;
  scrollbar-width: 0;
}

.messageProfile::-webkit-scrollbar {
  display: none;
}

.messageProfile__person {
  display: none;
  align-items: center;
  flex-direction: column;
  margin-bottom: 2rem;
}

.messageProfile__personImg {
  position: relative;
  width: -moz-fit-content;
  width: fit-content;
}

.messageProfile__person h3 {
  font-family: "Avenir Next";
  color: var(--clr-gray800);
  margin: 0.5rem 0 0.5rem 0;
  font-size: 1.1rem;
  font-weight: bolder;
  /* white-space: nowrap; */
  text-align: center;
}

.messageProfile__person span {
  font-size: 0.9rem;
  color: var(--clr-gray800);
}

.messageProfile__personImg::after {
  content: "";
  position: absolute;
  width: 0.85rem;
  height: 0.85rem;
  background: var(--clr-success-dark);
  border-radius: 50%;
  right: -0.25rem;
  border: 0.4rem solid var(--clr-light);
  bottom: 0.25rem;
}

.messageProfile__personImg img {
  width: 5rem;
  height: 5rem;
  aspect-ratio: 1 / 1;
  object-fit: cover;
  border-radius: 50%;
}

.messageProfile__menuLists {
  width: 100%;
  /* margin-top: 2rem; */
}

.messageProfile__menuList {
  display: flex;
  flex-direction: column;
  padding: 1em;
  border-radius: 1em;
  margin-top: 1rem;
  cursor: pointer;
  width: 100%;
  background: var(--clr-gray200);
}

.messageProfile__menuList > div:first-of-type {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 1.1rem;
  color: var(--clr-gray800);
}

.messageProfile__menuList.expand > div:first-of-type {
  border-bottom: 0.1rem solid var(--clr-gray);
  padding: 0 1em 1em 1em;
  width: calc(100% + 2rem);
  margin-left: -1rem;
}

.messageProfile__menuList.expand .messageProfile__menuExpand {
  max-height: 20rem;
  margin-top: 1rem;
  pointer-events: all;
  opacity: 1;
  overflow: auto;
  transition: max-height 1s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

.messageProfile__menuList.expand .messageProfile__chevronIcon {
  transform: rotate(180deg);
}

.messageProfile__menuExpand {
  max-height: 0;
  width: 100%;
  opacity: 0;
  padding: 0.25em;
  overflow: hidden;
  pointer-events: none;
  margin-top: 0;
  line-height: 1.8;
}

.messageProfile__menuList.expand .messageProfile__menuExpand {
  /* scrollbar-color: #44ee4e; */
  scrollbar-track-color: transparent;
  /* scrollbar-arrow-color: var(--clr-dark); */
  scrollbar-width: thin;
}

.messageProfile__menuList.expand
  .messageProfile__menuExpand::-webkit-scrollbar {
  width: 0.5rem;
  height: 0.5rem;
}

.messageProfile__menuList.expand
  .messageProfile__menuExpand::-webkit-scrollbar-track {
  background-color: transparent;
}

.messageProfile__menuList.expand
  .messageProfile__menuExpand::-webkit-scrollbar-thumb {
  background: var(--clr-primary-dark);
  border-radius: 3rem;
}

.messageProfile__menuLists li svg {
  display: block;
  /* width: 1.5rem; */
  margin-top: 0.5rem;
  width: 100%;
  max-width: 1.5rem;
}

.messageProfile__menuListExpand {
  margin-top: 0.75rem;
  color: var(--clr-primary);
}

.messageProfile__menuListExpand a {
  cursor: pointer;
}

.messageProfile__menuListExpand > div:first-of-type {
  display: flex;
  /* white-space: nowrap; */
  /* width: max-content; */
  /* align-items: center; */
  align-items: flex-start;
  width: -moz-fit-content;
  width: fit-content;
  /* white-space: ; */
}

.messageProfile__menuListExpand svg {
  margin-right: 0.75rem;
}

.messageProfile__menuListExpand a {
  color: var(--clr-primary);
  font-weight: bold;
}

.messageProfile__menuExpand {
  /* list-style: ; */
  color: var(--clr-dark);
  overflow-x: hidden;
}

.messageProfile__menuExpand.menu-propsals > li {
  display: flex;
  flex-direction: column;
  scrollbar-track-color: transparent;
  margin-bottom: 1rem;
  scrollbar-width: thin;
  color: var(--clr-primary);
  font-weight: bold;
  /* overflow-x: scroll; */
  overflow-x: hidden;
}

.messageProfile__menuExpand.menu-propsals > li::-webkit-scrollbar {
  width: 0.5rem;
  height: 0.5rem;
}

.messageProfile__menuExpand.menu-propsals > li::-webkit-scrollbar-track {
  background-color: transparent;
}

.messageProfile__menuExpand.menu-propsals > li::-webkit-scrollbar-thumb {
  background: var(--clr-primary-dark);
  border-radius: 3rem;
}

.messageProfile__menuExpand.menu-propsals .proposalCard {
  margin-top: 0.75rem;
}

@media (min-width: 992px) {
  .messageProfile {
    margin-top: 1rem;
    grid-column: 1 / -1;
  }

  .messageProfile__menuList {
    padding: 1.25em;
  }
}

@media (min-width: 1200px) {
  .messageProfile {
    flex: 1 1 30%;
    width: 100%;
    margin-top: 0;
    padding: 2em;
    border-radius: 0;
    background: var(--clr-gray200);
    border-left: 0.1rem solid var(--clr-gray);
  }

  .messageProfile__person {
    display: flex;
  }

  .messageProfile__menuList {
    padding: 1em;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/MessageComponents/MessageProfile/MessageProfile.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,uBAAkB;EAAlB,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,mCAAmC;EACnC,kBAAkB;EAClB,eAAe;EACf,qCAAqC;EACrC,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,2CAA2C;EAC3C,sBAAsB;EACtB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,UAAU;EACV,cAAc;EACd,iEAAiE;AACnE;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,WAAW;EACX,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,kCAAkC;EAClC,4CAA4C;EAC5C,qBAAqB;AACvB;;AAEA;;EAEE,aAAa;EACb,cAAc;AAChB;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;;EAEE,mCAAmC;EACnC,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,wBAAwB;EACxB,yBAAyB;EACzB,uBAAuB;EACvB,uBAAkB;EAAlB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kCAAkC;EAClC,mBAAmB;EACnB,qBAAqB;EACrB,yBAAyB;EACzB,iBAAiB;EACjB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,mCAAmC;EACnC,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,aAAa;IACb,WAAW;IACX,aAAa;IACb,YAAY;IACZ,gBAAgB;IAChB,8BAA8B;IAC9B,yCAAyC;EAC3C;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,YAAY;EACd;AACF","sourcesContent":[".messageProfile {\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  width: 100%;\n  overflow-y: scroll;\n  scrollbar-width: 0;\n}\n\n.messageProfile::-webkit-scrollbar {\n  display: none;\n}\n\n.messageProfile__person {\n  display: none;\n  align-items: center;\n  flex-direction: column;\n  margin-bottom: 2rem;\n}\n\n.messageProfile__personImg {\n  position: relative;\n  width: fit-content;\n}\n\n.messageProfile__person h3 {\n  font-family: \"Avenir Next\";\n  color: var(--clr-gray800);\n  margin: 0.5rem 0 0.5rem 0;\n  font-size: 1.1rem;\n  font-weight: bolder;\n  /* white-space: nowrap; */\n  text-align: center;\n}\n\n.messageProfile__person span {\n  font-size: 0.9rem;\n  color: var(--clr-gray800);\n}\n\n.messageProfile__personImg::after {\n  content: \"\";\n  position: absolute;\n  width: 0.85rem;\n  height: 0.85rem;\n  background: var(--clr-success-dark);\n  border-radius: 50%;\n  right: -0.25rem;\n  border: 0.4rem solid var(--clr-light);\n  bottom: 0.25rem;\n}\n\n.messageProfile__personImg img {\n  width: 5rem;\n  height: 5rem;\n  aspect-ratio: 1 / 1;\n  object-fit: cover;\n  border-radius: 50%;\n}\n\n.messageProfile__menuLists {\n  width: 100%;\n  /* margin-top: 2rem; */\n}\n\n.messageProfile__menuList {\n  display: flex;\n  flex-direction: column;\n  padding: 1em;\n  border-radius: 1em;\n  margin-top: 1rem;\n  cursor: pointer;\n  width: 100%;\n  background: var(--clr-gray200);\n}\n\n.messageProfile__menuList > div:first-of-type {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  font-size: 1.1rem;\n  color: var(--clr-gray800);\n}\n\n.messageProfile__menuList.expand > div:first-of-type {\n  border-bottom: 0.1rem solid var(--clr-gray);\n  padding: 0 1em 1em 1em;\n  width: calc(100% + 2rem);\n  margin-left: -1rem;\n}\n\n.messageProfile__menuList.expand .messageProfile__menuExpand {\n  max-height: 20rem;\n  margin-top: 1rem;\n  pointer-events: all;\n  opacity: 1;\n  overflow: auto;\n  transition: max-height 1s cubic-bezier(0.175, 0.885, 0.32, 1.275);\n}\n\n.messageProfile__menuList.expand .messageProfile__chevronIcon {\n  transform: rotate(180deg);\n}\n\n.messageProfile__menuExpand {\n  max-height: 0;\n  width: 100%;\n  opacity: 0;\n  padding: 0.25em;\n  overflow: hidden;\n  pointer-events: none;\n  margin-top: 0;\n  line-height: 1.8;\n}\n\n.messageProfile__menuList.expand .messageProfile__menuExpand {\n  /* scrollbar-color: #44ee4e; */\n  scrollbar-track-color: transparent;\n  /* scrollbar-arrow-color: var(--clr-dark); */\n  scrollbar-width: thin;\n}\n\n.messageProfile__menuList.expand\n  .messageProfile__menuExpand::-webkit-scrollbar {\n  width: 0.5rem;\n  height: 0.5rem;\n}\n\n.messageProfile__menuList.expand\n  .messageProfile__menuExpand::-webkit-scrollbar-track {\n  background-color: transparent;\n}\n\n.messageProfile__menuList.expand\n  .messageProfile__menuExpand::-webkit-scrollbar-thumb {\n  background: var(--clr-primary-dark);\n  border-radius: 3rem;\n}\n\n.messageProfile__menuLists li svg {\n  display: block;\n  /* width: 1.5rem; */\n  margin-top: 0.5rem;\n  width: 100%;\n  max-width: 1.5rem;\n}\n\n.messageProfile__menuListExpand {\n  margin-top: 0.75rem;\n  color: var(--clr-primary);\n}\n\n.messageProfile__menuListExpand a {\n  cursor: pointer;\n}\n\n.messageProfile__menuListExpand > div:first-of-type {\n  display: flex;\n  /* white-space: nowrap; */\n  /* width: max-content; */\n  /* align-items: center; */\n  align-items: flex-start;\n  width: fit-content;\n  /* white-space: ; */\n}\n\n.messageProfile__menuListExpand svg {\n  margin-right: 0.75rem;\n}\n\n.messageProfile__menuListExpand a {\n  color: var(--clr-primary);\n  font-weight: bold;\n}\n\n.messageProfile__menuExpand {\n  /* list-style: ; */\n  color: var(--clr-dark);\n  overflow-x: hidden;\n}\n\n.messageProfile__menuExpand.menu-propsals > li {\n  display: flex;\n  flex-direction: column;\n  scrollbar-track-color: transparent;\n  margin-bottom: 1rem;\n  scrollbar-width: thin;\n  color: var(--clr-primary);\n  font-weight: bold;\n  /* overflow-x: scroll; */\n  overflow-x: hidden;\n}\n\n.messageProfile__menuExpand.menu-propsals > li::-webkit-scrollbar {\n  width: 0.5rem;\n  height: 0.5rem;\n}\n\n.messageProfile__menuExpand.menu-propsals > li::-webkit-scrollbar-track {\n  background-color: transparent;\n}\n\n.messageProfile__menuExpand.menu-propsals > li::-webkit-scrollbar-thumb {\n  background: var(--clr-primary-dark);\n  border-radius: 3rem;\n}\n\n.messageProfile__menuExpand.menu-propsals .proposalCard {\n  margin-top: 0.75rem;\n}\n\n@media (min-width: 992px) {\n  .messageProfile {\n    margin-top: 1rem;\n    grid-column: 1 / -1;\n  }\n\n  .messageProfile__menuList {\n    padding: 1.25em;\n  }\n}\n\n@media (min-width: 1200px) {\n  .messageProfile {\n    flex: 1 1 30%;\n    width: 100%;\n    margin-top: 0;\n    padding: 2em;\n    border-radius: 0;\n    background: var(--clr-gray200);\n    border-left: 0.1rem solid var(--clr-gray);\n  }\n\n  .messageProfile__person {\n    display: flex;\n  }\n\n  .messageProfile__menuList {\n    padding: 1em;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
